// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetEventCheckoutByIdRequestModel from '../../model/get-event-checkout-by-id-request-model';
import GetEventCheckoutByIdRequestDTO from '../dto/get-event-checkout-by-id-request-dto';
import dtoSchema from '../schemas/get-event-checkout-by-id-request-schema';

export default abstract class GetEventCheckoutByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetEventCheckoutByIdRequestDTO>) {
    super();
    if (data) {
      this.eventId = data.eventId;
      this.id = data.id;
    }
  }
  /**
  * @type {uuid}
  */
  eventId?: string;
  /**
  * @type {uuid}
  */
  id?: string;

  static toModel(dto: DeepPartial<GetEventCheckoutByIdRequestDTO>): GetEventCheckoutByIdRequestModel;
  static toModel(dto: DeepPartial<GetEventCheckoutByIdRequestDTO> | undefined | null): GetEventCheckoutByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetEventCheckoutByIdRequestDTO> | undefined | null): GetEventCheckoutByIdRequestModel | undefined {
    return dto ? new GetEventCheckoutByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetEventCheckoutByIdRequestModel> | GetEventCheckoutByIdRequestModel): GetEventCheckoutByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      eventId: unwrapped.eventId,
      id: unwrapped.id,
    } as GetEventCheckoutByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetEventCheckoutByIdRequestModel, can not map to GetEventCheckoutByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
